import React from "react";
import { useEstadoFactura } from "../hooks/useEstadoFactura";

// Badge reutilizable para tablas (por defecto renderiza un <td>).
// Para vistas de detalle que usan un componente de título (TitleH2Component,
// etc.) en vez de una celda, usa directamente el hook useEstadoFactura.
const EstadoFacturaComponent = ({
  estado,
  fechaVencimiento,
  tipo = "venta",
  as: Tag = "td",
  styleGroup = "",
}) => {
  const { calcularEstadoFactura } = useEstadoFactura();

  const { text, className } = calcularEstadoFactura({
    estado,
    fechaVencimiento,
    tipo,
  });

  return (
    <Tag className={`text-center ${className} ${styleGroup}`}>{text}</Tag>
  );
};

export default EstadoFacturaComponent;
